/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { buildGetRequest } from "../../utils/Requests";
import { MaterialSnapshotAggregate, Pagination } from "../../utils/Interfaces";

export function getMaterialReportAggregate(startDate: string, endDate: string) {
    return buildGetRequest<Pagination<MaterialSnapshotAggregate>>(`/api/materials/report/aggregate/${startDate}/${endDate}`);
}
